<a
  class="article full-width"
  [href]="'/' + article.slug"
  appSpot
  [text]="'Découvrir'"
  [icon]="'/icons/seeMore.svg'"
  [backgroundColor]="'#D17A2A'"
>
  <section>
    <div
      class="cover"
      appRatio
      [x]="16"
      [y]="9"
      [style.background-image]="articleImageSrc"
      appZoom
      [picture]="article.coverPicture"
      #wrapper
    ></div>
    @if(article.destination){
    <p class="upper">
      {{ article.place }}, <em>{{ article.destination.country }}</em>
    </p>
    }
    <h3>{{ article.name }}</h3>
    @if(showDescription){
    <div class="description" *ngIf="showDescription">
      <app-inner-html [content]="getArticleDescription(article)"></app-inner-html>
    </div>
    }
  </section>
</a>
